import { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import { Stack, Typography, useTheme, useMediaQuery } from "@mui/material";
import Card from "@mui/material/Card";
import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";
import { HttpMainApi } from "../../interface/main-api";
import { userState } from "../../interface/MainInterface";
import "react-calendar/dist/Calendar.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { useNavigate } from "react-router-dom";
import { getFormattedDateTime } from "../../utils/getFormattedDateTime";
import ReservDeskList from "../components/ReservDeskList";

const mainApi = new HttpMainApi();
interface propsType {
  userState: userState;
  userInfo: userState;
  handleClose: () => void;
}
interface ReservationDetail {
  deviceNum: string;
  reservTime: string;
  reservDt: string;
  userName: string;
  userId: string;
  inputDt: string;
}
interface Reservation {
  sk: string;
  pk: string;
  reservations: { [key: string]: ReservationDetail };
}
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  width: "70%",
  transform: "translate(-50%, -50%)",

  bgcolor: "background.paper",
  boxShadow: 24,
  "& img": {
    width: "80%",
    height: "auto", // 이미지의 원본 비율을 유지합니다.
  },
};
const ReservationStudyAdmin = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [reservOn, setReservOn] = useState(true);
  const manRooms = [];
  for (let i = 1; i <= 21; i++) {
    const roomNumber = i.toString().padStart(2, "0");
    manRooms.push(`M${roomNumber}`);
  }
  const womanRooms = [];
  for (let i = 1; i <= 20; i++) {
    const roomNumber = i.toString().padStart(2, "0");
    womanRooms.push(`W${roomNumber}`);
  }

  const buttons = [
    { key: "남자독서실", label: "남자 독서실" },
    { key: "여자독서실", label: "여자 독서실" },
  ];

  const [selectedGubun, setSelectedGubun] = useState(buttons[0].key);
  const [selectedDesk, setSelectedDesk] = useState(null);

  const handleButtonClick = (buttonKey: any) => {
    setSelectedDesk(null);
    setSelectedGubun(buttonKey);
  };
  const handleDeskButtonClick = (time: any) => {
    setSelectedDesk(time);
  };
  function formatYearMonth(selectYearMonth: string) {
    const regex = /(\d{4})년 (\d{1,2})월/;
    const matches = selectYearMonth.match(regex);
    if (matches) {
      const year = matches[1];
      const month = matches[2].padStart(2, "0");
      return `${year}${month}`;
    }

    return ""; // 매칭되지 않는 경우 빈 문자열 반환
  }

  const reservation_save = async () => {
    const formatted = formatYearMonth(selectYearMonth);
    const { formattedDateTime, formatdaypk } = getFormattedDateTime();
    const userId = props.userInfo.userId;
    const userAddr = props.userInfo.readAddress;
    const userName = props.userInfo.userName;
    const pk = `${formatted}/STUDY`;

    const param: any = {
      pk: pk,
      sk: selectedGubun,
      option: selectedDesk,
      userId: userId,
      userAddr: userAddr,
      userName: userName,
      inputDt: formattedDateTime,
      reservDt: selectYearMonth,
      my_pk: pk,
      my_sk: `${formatted}${formatdaypk}`,
      communityPrice: communityPrice,
    };
    const res = await mainApi.put_reserv_month(param);
    if (res.code === "200") {
      setAlertOpen(false);
      props.handleClose();
      alert("예약 완료되었습니다.");
    } else if (res.code === "601") {
      setAlertOpen(false);
      alert("이미 예약된 좌석입니다.\n다시 조회 후 진행해주세요.");
      props.handleClose();
    } else if (res.code === "600") {
      setAlertOpen(false);
      alert("[1인 1좌석] 이미 예약된 좌석이 있습니다.");
      props.handleClose();
    } else {
      setAlertOpen(false);
      props.handleClose();
      alert(
        `알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`
      );
    }
  };

  const [times, setTimes] = useState<string[]>([]);
  const extractReservationTimes = (
    reservationData: Reservation[]
  ): string[] => {
    const times: string[] = [];

    reservationData.forEach((item) => {
      Object.keys(item.reservations).forEach((time) => {
        times.push(time);
      });
    });
    return times;
  };

  const get_day_reservation = async () => {
    setIsLoading(true);
    const formatted = formatYearMonth(selectYearMonth);
    const pk = `${formatted}/STUDY`;
    const sk = selectedGubun;
    const param: any = {
      pk: pk,
      sk: sk,
    };
    const res = await mainApi.get_day_reservation(param);
    if (res.code === "200") {
      const extractedTimes = extractReservationTimes(res.response.result);
      setTimes(extractedTimes);
    } else if (res.code === "400") {
    } else {
      alert(
        `알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`
      );
    }
    setIsLoading(false);
  };

  const [months, setMonths] = useState<string[]>([]);
  const [selectYearMonth, setSelectYearMonth] = useState<string>("");
  const [useDate, setUseDate] = useState("");
  const [selectedMonthGubun, setSelectedMonthGubun] = useState(0);

  useEffect(() => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    // 현재 월과 다음 두 달을 계산합니다.
    const monthsArray = [
      new Date(currentYear, currentMonth - 1, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      }),
      new Date(currentYear, currentMonth, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      }),
      new Date(currentYear, currentMonth + 1, 1).toLocaleDateString("default", {
        year: "numeric",
        month: "long",
      }),
    ];

    setMonths(monthsArray);
    setSelectYearMonth(monthsArray[1]);
  }, []);

  const monthButtonClick = (monthName: string, index: number) => {
    const selectedYearMonth = monthName;
    setSelectYearMonth(selectedYearMonth);
    setSelectedMonthGubun(index);
    setSelectedDesk(null);
  };

  const displayMonthName = (monthName: string) => {
    return monthName?.substring(6);
  };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 2).toString().padStart(2, "0");
    setUseDate(year + month);
  }, []);

  useEffect(() => {
    get_day_reservation();
  }, [selectedGubun, selectYearMonth]);

  const [alertOpen, setAlertOpen] = useState(false);
  const handleClickOpen = () => {
    if (
      selectedGubun === "" ||
      selectedGubun === undefined ||
      selectedGubun === null
    ) {
      toastRef.current?.toast(
        "남자(여자) 독서실을 선택하세요.",
        "error",
        4000,
        {
          vertical: "top",
          horizontal: "center",
        }
      );
      return;
    }

    if (
      selectedDesk === "" ||
      selectedDesk === undefined ||
      selectedDesk === null
    ) {
      toastRef.current?.toast("좌석번호를 선택하세요.", "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
      return;
    }
    setAlertOpen(true);
  };
  const handleClose = () => {
    setAlertOpen(false);
  };

  const [manOpen, setManOpen] = useState(false);
  const handleManOpen = () => setManOpen(true);
  const handleManClose = () => setManOpen(false);
  const [womanOpen, setWomanOpen] = useState(false);
  const handleWomanOpen = () => setWomanOpen(true);
  const handleWomanClose = () => setWomanOpen(false);

  const [communityPrice, setCommunityPrice] = useState(0);
  const get_price = async () => {
    const pk = "COMMUNITY/ACCOUNT";
    const sk = "독서실";
    const param: any = {
      pk: pk,
      sk: sk,
    };
    const res = await mainApi.get_price(param);
    if (res.code === "200") {
      setCommunityPrice(res.response.result[0]["PRICE"]);
    } else {
      alert(
        `알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`
      );
    }
  };

  const diffDay = ["25", "26", "27", "28", "29", "30", "31"];
  useEffect(() => {
    get_price();
    const { formatday } = getFormattedDateTime();
    if (diffDay.includes(formatday)) {
      setReservOn(true);
    } else {
      setReservOn(false);
    }
  }, []);

  function formatLastDayOfMonth(detailsReservDt: string): string {
    // 입력된 detailsReservDt에서 연도와 월을 추출
    const year = detailsReservDt.substring(0, 4);
    const month = detailsReservDt.substring(4, 6);

    // Date 객체를 생성, 다음 달의 첫 날을 나타내도록 설정
    // 주의: JavaScript의 Date는 월을 0부터 시작으로 취급하기 때문에 month에서 1을 빼주지 않습니다.
    const date = new Date(Number(year), Number(month) - 1, 0);
    // Date 객체를 사용하여 전달의 마지막 날짜를 구하고, 원하는 포맷으로 변환
    const formattedDate = `${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}월 ${String(date.getDate()).padStart(2, "0")}일 `;
    return formattedDate;
  }
  return (
    <>
      <Stack
        spacing={2}
        alignItems="center"
        justifyContent="center"
        sx={{
          width: "100%",
          maxWidth: isMobile ? "100%" : "40rem",
          margin: "auto",
        }}
      >
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 300,
              textAlign: "left",
              margin: "auto",
              mt: 2,
              ml: 3,
            }}
          ></Typography>
        </Box>

        <>
          <Box
            sx={{
              width: "90%",
              maxWidth: isMobile ? "100%" : "40rem",
              margin: "auto",
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "center", alignItems: "center" }}
            >
              <Typography
                gutterBottom
                variant="h6"
                component="div"
                style={{ color: "#0000FF" }}
              >
                {props.userInfo.userName}님 {displayMonthName(months[1])} 신청
              </Typography>
            </Stack>
          </Box>

          <ButtonGroup size="large" aria-label="large button group">
            {buttons.map((button) => (
              <Button
                key={button.key}
                style={{
                  borderColor: "#2E3341",
                  color: selectedGubun === button.key ? "#ffffff" : "#2E3341",
                  backgroundColor:
                    selectedGubun === button.key ? "#2E3341" : "",
                }}
                onClick={() => handleButtonClick(button.key)}
              >
                {button.label}
              </Button>
            ))}
          </ButtonGroup>

          <Box
            sx={{
              width: "100%",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{
                fontWeight: 300,
                textAlign: "left",
                margin: "auto",
                ml: 3,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              좌석도면 확인
              <ArrowRightAltIcon />
              <ManIcon sx={{ cursor: "pointer" }} onClick={handleManOpen} />
              <WomanIcon
                sx={{ ml: 2, cursor: "pointer" }}
                onClick={handleWomanOpen}
              />
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
            }}
          >
            <ReservDeskList
              userState={props.userState}
              reserv_desk={
                selectedGubun === "남자독서실"
                  ? manRooms
                  : selectedGubun === "여자독서실"
                  ? womanRooms
                  : []
              }
              handleDeskButtonClick={handleDeskButtonClick}
              selectedDesk={selectedDesk}
              chunkNum={4}
              times={times}
            />
          </Box>

          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
              justifyContent: "center",
              width: "95%", // 전체 너비를 사용하도록 설정
              height: "4em",
              marginTop: "3em",
            }}
          >
            <Button
              sx={{
                borderRadius: "10px",
                border: "1px solid #ccc",
                width: "100%",
              }}
              color="primary"
              variant="contained"
              endIcon={<CheckIcon />}
              onClick={() => handleClickOpen()}
            >
              <Typography variant="h6">
                {displayMonthName(months[1])} 신청 하기
              </Typography>
            </Button>
          </Stack>
        </>
      </Stack>
      <Stack
        direction="row"
        sx={{
          flexWrap: "wrap",
          justifyContent: "center",
          width: "95%",
          height: "2em",
          marginTop: "3em",
        }}
      ></Stack>
      <Dialog
        open={alertOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "80%",
            maxWidth: "500px",
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          {"신청 하시겠습니까?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            [독서실 신청 정보]
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            신청자 : {props.userInfo.userName}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            사용 기간 : {selectYearMonth}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            좌석 번호 : [{selectedGubun}] {selectedDesk}
          </DialogContentText>
          <DialogContentText id="alert-dialog-description">
            이용료 : {communityPrice}원
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>취소</Button>
          <Button onClick={reservation_save} autoFocus>
            신청
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={manOpen}
        onClose={handleManClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src="/images/study_01.png" alt="logo" />
        </Box>
      </Modal>
      <Modal
        open={womanOpen}
        onClose={handleWomanClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src="/images/study_02.png" alt="logo" />
        </Box>
      </Modal>
      <Toast ref={toastRef} />
      <LoadingCircle loading={isLoading} />
    </>
  );
};

export default ReservationStudyAdmin;
